import ReactGA from 'react-ga4';
// Initialize Google Analytics
export const initGA = (measurementId: string) => {
  if (measurementId) {
    ReactGA.initialize(measurementId);
  }
};

// Track page views
export const trackPageView = (page: string) => {
  ReactGA.send({ hitType: 'pageview', page });
};

// Track custom events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track event page views
export const trackEventPageView = (eventSlug: string) => {
  trackEvent('page_view', 'view_event_page', eventSlug);
};

// Track portfolio page views
export const trackPortfolioPageView = (portfolioSlug: string) => {
  trackEvent('page_view', 'view_portfolio_page', portfolioSlug);
}; 